import { Injector, Signal, inject } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { PlatformSuppliersService } from '../platform-suppliers.service';

import { platformSuppliersKeys } from './platform-suppliers.query-keys';

export function injectPlatformSuppliersQuery(searchTerm: Signal<string>, injector: Injector = inject(Injector)) {
  const platformSuppliersService: PlatformSuppliersService = injector.get(PlatformSuppliersService);

  return injectQuery(
    () => ({
      queryKey: platformSuppliersKeys.platformSuppliers(searchTerm()),
      staleTime: 600_000,
      queryFn: () => lastValueFrom(platformSuppliersService.getAllPlatformSuppliers(searchTerm())),
      refetchOnWindowFocus: false,
    }),
    injector,
  );
}
